import {
  EServiceType,
  ICheckPublishTermSchema,
} from '../../../../repositories/billing-tariffs/entities/PublishTerms/CheckPublishTermSchema';
import { IServicePeriod } from '../../../../types/reducers/publishTerms';

interface IMapAuctionTermParams {
  bet: number;
  period: IServicePeriod;
  days: number;
}

export function mapAuctionTerm(params: IMapAuctionTermParams): ICheckPublishTermSchema {
  const { bet, period, days } = params;
  const { tariffIdentificator, token } = period;
  const type = days > 1 ? 'periodical' : 'dailyTermless';

  return {
    type,
    days,
    services: [EServiceType.auction],
    tariffIdentificator,
    dynamicPrice: bet,
    token,
  };
}
